/**
 * Welke omgeving deze build is (security-besluit 03-11-2026):
 * - 'club'  → beheer.antreja.nl: alleen clubgebruikers; Antreja-onderdelen zitten niet in de bundel.
 * - 'admin' → admin.antreja.nl: alleen het Antreja-team (achter Cloudflare Access).
 * - 'all'   → demo en tests: alles (geen productie).
 * Productie zonder VITE_SURFACE is altijd 'club' (veilige standaard).
 */
export type Surface = 'club' | 'admin' | 'all';

const raw = import.meta.env.VITE_SURFACE as string | undefined;
export const SURFACE: Surface = raw === 'admin' ? 'admin' : raw === 'club' ? 'club' : import.meta.env.VITE_DEMO === 'true' || import.meta.env.DEV ? 'all' : 'club';

export const CLUB_URL = 'https://beheer.antreja.nl';
export const ADMIN_URL = 'https://admin.antreja.nl';

/** Mag dit account in deze omgeving werken? null = ja, anders de uitleg. */
export function surfaceBlock(surface: Surface, platformRole: string | null): { title: string; text: string; url: string } | null {
  if (surface === 'club' && platformRole !== null) {
    return {
      title: 'Dit is de omgeving voor clubs',
      text: 'Je logt in met een account van het Antreja-team. Dat werkt alleen in de beheeromgeving van Antreja.',
      url: ADMIN_URL,
    };
  }
  if (surface === 'admin' && platformRole === null) {
    return {
      title: 'Dit is de beheeromgeving van Antreja',
      text: 'Alleen medewerkers van Antreja kunnen hier inloggen. Clubs loggen in via het clubportaal.',
      url: CLUB_URL,
    };
  }
  return null;
}
